import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { Box, Skeleton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { usePartial } from 'shared/hooks/utils';
import { showEventOnMap } from 'console/redux/main-actions';
import { dateTimeInPast } from 'webui/utils/time';
import * as S from './styles';
import { selectDevId2Name } from 'entities/device/lib';
import { useEventVehicleAddress } from 'console/shared/hooks/vehicle';
import { onNewEvent } from 'console/tabs/events/utils';
export const EventItem = memo(function EventItem(props) {
    const { loc_event, device_id, isDeviceAllEvents } = props;
    const { x, y, details, title, important, icon, time } = loc_event;
    const selector_device_name = useAppSelector(selectDevId2Name);
    const device_name = selector_device_name[device_id];
    const newEvent = onNewEvent(loc_event, device_name);
    const onClickShowEventMap = useAction(usePartial(showEventOnMap, newEvent));
    const onClickHandler = useCallback(() => {
        if (x != null && y != null) {
            onClickShowEventMap();
        }
    }, [onClickShowEventMap, x, y]);
    const theme = useTheme();
    const recieve_date = dateTimeInPast(new Date(time * 1e3), {
        withSeconds: true,
    });
    const [ref_in_view, address] = useEventVehicleAddress(device_id, x != null && y != null ? [x, y] : null);
    const address_view = useMemo(() => {
        if (x == null || y == null) {
            return null;
        }
        if (address.length === 0) {
            return _jsx(Skeleton, { width: 150 });
        }
        return (_jsx(Typography, { variant: "body2", color: "textSecondary", children: address }));
    }, [x, y, address]);
    const text_color = useMemo(() => {
        if (loc_event.type === 'MainPowerFound') {
            return '#03a600';
        }
        if (important) {
            return 'error';
        }
        return 'textPrimary';
    }, [important, loc_event.type]);
    const image_color = useMemo(() => {
        if (loc_event.type === 'MainPowerFound') {
            return 'brightness(0) saturate(100%) invert(37%) sepia(48%) saturate(3180%) hue-rotate(89deg) brightness(100%) contrast(104%)';
        }
        if (important) {
            return 'invert(41%) sepia(8%) saturate(5261%) hue-rotate(317deg) brightness(89%) contrast(100%)';
        }
        if (theme.palette.mode === 'dark') {
            return 'invert(99%) sepia(41%) saturate(2%) hue-rotate(252deg) brightness(106%) contrast(101%)';
        }
        return '';
    }, []);
    return (_jsxs(S.EventItem, { onClick: onClickHandler, add_pointer: (x != null && y != null) || isDeviceAllEvents, ref: ref_in_view, children: [_jsx(Box, { display: "flex", mr: 2, alignSelf: "center", sx: {
                    '& > img': {
                        filter: image_color,
                    },
                }, children: _jsx("img", { width: 24, height: 24, src: `${window.ZONT_URL.api_event_icon}?type=${icon}`, alt: title }) }), _jsxs(Box, { display: "flex", justifyContent: "space-between", width: "100%", children: [_jsxs(Box, { display: "flex", flexDirection: "column", children: [isDeviceAllEvents && (_jsx(Typography, { color: 'primary.dark', children: device_name })), _jsx(Typography, { variant: "body2", color: text_color, children: title }), address_view, _jsx(Typography, { variant: "body2", color: "textSecondary", children: details })] }), _jsx(Typography, { variant: "body2", textAlign: "right", color: "textSecondary", textTransform: "capitalize", children: recieve_date })] })] }));
});
